import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export function useBrowserWarningNavigate(message, when = true) {
  const location = useLocation();
  const navigate = useNavigate();
  const hasPushedRef = useRef(false);

  useEffect(() => {
    if (!when) return;

    if (!hasPushedRef.current) {
      window.history.pushState(null, "", window.location.href);
      hasPushedRef.current = true;
    }

    const handlePopState = (event) => {
      const confirmLeave = window.confirm(message);

      if (confirmLeave) {
        navigate(-1);
      } else {
        window.history.forward();
      }
    };

    window.addEventListener("popstate", handlePopState);
    hasPushedRef.current = false;

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [when, message, navigate, location]);

  useEffect(() => {
    if (!when) return;

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = message;
      return message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [message, when]);
}
